export default "__VITE_ASSET__C9Zp9Gv9__"